module.exports = __webpack_public_path__ + "arrow-pointing-to-left.5190b858758ce784050f7842e48238ee.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/arrow-pointing-to-left.svg
// module id = 407
// module chunks = 0